import styled from '@emotion/styled';

const CapitalisedHeading = styled.h2`
  text-transform: capitalize;
  margin-bottom: 0;
`;

export default CapitalisedHeading;
